
import React, { memo, useCallback, useMemo, useState } from 'react'
import './DataListComp.css'
import { useEffect } from 'react';
import { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import GlidGrid from '../../Components/Grid/GlidGrid';
import { AlertPopup, FileDownloader, GridActionButton, convertKeysToUpperCase } from '../../Asset/common';
import generateExcel from '../../Components/Grid/ExcelGenerator';
import { fetchDataNew as DynamicFetchNew, addData } from '../../Redux/Slices/Transaction/DynamicSlice';
import { Form, useNavigate } from 'react-router-dom';
import { FaHandHoldingMedical, FaLink, FaRectangleList } from 'react-icons/fa6';
import { RiCloseCircleFill, RiFilterFill, RiWhatsappFill } from 'react-icons/ri';
import { IoMdDownload, IoMdRefresh, IoMdRefreshCircle } from 'react-icons/io';
import { Button, Card, Modal } from 'react-bootstrap';
import '../../Pages/Mix/Transaction/MixMaster.css'
import useAutoAdjustHeight from '../../Components/useAutoAdjustHeight/useAutoAdjustHeight';
import { fetchWebStockPartyData } from '../../Redux/Slices/Masters/PacketSearchSlice';
import { FaMobileAlt } from 'react-icons/fa';
import PktSearchMobViewComp from '../Transaction/PktSearchMobViewComp';
import { startLoader, stopLoader } from '../../Redux/Slices/Utility/loaderSlice';
import { MdFileDownload, MdPersonRemoveAlt1 } from 'react-icons/md';
import { BiSelectMultiple } from 'react-icons/bi';
import roundShape from '../../../src/Asset/Image/Shape/Round.png';
import asscherShape from '../../../src/Asset/Image/Shape/Asscher.png';
import baguetteShape from '../../../src/Asset/Image/Shape/Baguettepng.png';
import cushionShape from '../../../src/Asset/Image/Shape/cushion.png';
import emeraldShape from '../../../src/Asset/Image/Shape/Emerald.png';
import heartShape from '../../../src/Asset/Image/Shape/Heart.png';
import marquiseShape from '../../../src/Asset/Image/Shape/Marquise.png';
import ovalShape from '../../../src/Asset/Image/Shape/Oval.png';
import pearShape from '../../../src/Asset/Image/Shape/Pear.png';
import princessShape from '../../../src/Asset/Image/Shape/Princess.png';
import radiantShape from '../../../src/Asset/Image/Shape/Radiant.png';
import trillionShape from '../../../src/Asset/Image/Shape/Trillion.png';
import Loader from '../Utility/Loader';
import flaglogo from '../../../src/Asset/Image/indian-flag_1.jpg';
import { HttpMethod } from '../../Asset/httpMethod';
import { getCode } from 'country-list';
import SampleFile from '../ImportExcelSympleFile/Party Stock Sample File.xlsx';
import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';
import FileImpComp from '../Transaction/FileImpComp';
import { PrismAsyncLight } from 'react-syntax-highlighter';

function DataListComp(props) {

    let APISetting = useSelector(state => state.APISetting);
    const [isModalOpen, setModalOpen] = useState(false);
    const [isModalVideoLink, setisModalVideoLink] = useState(false);
    const [VideoLinkRow, setVideoLinkRow] = useState([]);
    const [LocationColConfig, setLocationColConfig] = useState([]);
    const [AccColConfig, setAccColConfig] = useState([]);
    const { btn } = props;
    const btnValues = btn.split(',');
    const [objTotal, setobjTotal] = useState([])
    const PageName = props.PageName;
    let [objViewPara, setobjViewPara] = useState(props.ViewPara)
    console.log('props.ViewPara', props.ViewPara, objViewPara);
    let [objDs, setobjDs] = useState(JSON.parse(JSON.stringify(props.DataSrc) || '[]'));
    const dataDivRef = useRef(null);
    const dispatch = useDispatch();
    const [ObjSelTotal, setObjSelTotal] = useState({})

    let [Selectedrow, setSelectedrow] = useState([]);
    const [Party, setParty] = useState(null);
    const [PKTIDList, setPKTIDList] = useState(null);
    const [PagingRange, setPagingRange] = useState(null);
    const [showTotal, setShowTotal] = useState(true);
    const [openPacketSearchCom, setopenPacketSearchCom] = useState(false)
    let [GetViewPara, setGetViewPara] = useState([]);
    const [APIDataViewPara, setAPIDataViewPara] = useState([]);
    const [GetPlatform, setGetPlatform] = useState([]);
    const [pagebtnNaviName, setpagebtnNaviName] = useState('');
    const [IsMobView, setIsMobView] = useState(false);
    let [ViewType, setViewType] = useState('GridView');

    const columnConfigRecord = useSelector(state => state.ColumnConfig.visible);
    const DropDown = useSelector(state => state.DropDown);
    const pageName = PageName === 'STONESEARCH' ? 'STONESEARCH' : 'PACKETSEARCH';

    let [visibleItems, setVisibleItems] = useState([]);
    const [itemsPerPage] = useState(12);
    const [cardViewHeight, setcardViewHeight] = useState(0);
    let [SelectedPlatformName, setSelectedPlatformName] = useState('');
    const [PageRange, setPageRange] = useState([]);


    const [showModalParty, setShowModalParty] = useState(false);
    const [partyName, setPartyName] = useState('');


    const shapeImageMap = {
        'ROUND': roundShape,
        'ASSCHER': asscherShape,
        'BAGUETTE': baguetteShape,
        'CUSHION': cushionShape,
        'EMERALD': emeraldShape,
        'HEART': heartShape,
        'MARQUISE': marquiseShape,
        'OVAL': ovalShape,
        'PEAR': pearShape,
        'PRINCESS': princessShape,
        'RADIANT': radiantShape,
        'TRILLION': trillionShape
    };

    useEffect(() => {
        const fetchPageRangeData = () => {
            let GetPageRangeDropDown = DropDown.LOOKUPMAST?.filter(x => x.TYP == 'SearchPageRecerd');
            setPageRange(GetPageRangeDropDown);
        }

        fetchPageRangeData();
    }, [DropDown])

    useEffect(() => {
        if (PageRange?.length > 0) {
            setPagingRange(PageRange[0]); // Set the first item as the default
        }
    }, [PageRange]);

    useEffect(() => {
        getAllData();
    }, [props.DataSrc]);

    useEffect(() => {
        setobjViewPara(props.ViewPara);
    }, [props.ViewPara])


    countries.registerLocale(enLocale);
    const GetselectedRow = (selectedRows, lastEditedRow) => {
        // if (Selectedrow?.length) {
        //     selectedRows?.forEach((row) => {
        //         let filterRecordRowIndex = Selectedrow?.findIndex(x => x.PKTID == row.PKTID)
        //         if (filterRecordRowIndex != -1) {
        //             Selectedrow[filterRecordRowIndex] = row;
        //         }
        //         else {
        //             setSelectedrow(selectedRows);
        //         }
        //     })

        // }
        // else {
        setSelectedrow(selectedRows);
        Selectedrow = selectedRows;
        // }

        selectedRows?.forEach((row) => {
            let filterRecordRowIndex = objDs?.findIndex(x => x.PKTID == row.PKTID)
            if (filterRecordRowIndex != -1) {
                objDs[filterRecordRowIndex] = row;
            }
        })

        setobjDs(objDs)
    }

    const Columnconfigs = () => {
        setGetViewPara(columnConfigRecord?.filter(x => x.MenuCode == 'STONESEARCH'));
        setGetPlatform(columnConfigRecord?.filter(x => x.MenuCode == 'PLATFORMAPI'));
        setLocationColConfig(columnConfigRecord?.filter(x => x.MenuCode == 'PKTSEARCHLOCMAST'));
        setAccColConfig(columnConfigRecord?.filter(x => x.MenuCode == 'PKTSEARCHACCMAST'));
        setAPIDataViewPara(columnConfigRecord?.filter(x => x.MenuCode == 'GETSTKDATA'));
    }
    useEffect(() => {
        Columnconfigs();
    }, [])

    const ExcelGen = async (selectedRows, ConfigName, fileName) => {
        const filteredColumns = columnConfigRecord?.filter(column => column.MenuCode == ConfigName && column.IsExcelHide === false);
        filteredColumns.sort((a, b) => a.ExcelOrd - b.ExcelOrd);
        generateExcel(filteredColumns, selectedRows, fileName).catch(err => AlertPopup.errorPopup(err));
    }


    const addToHold = () => {
        if (!partyName) {
            AlertPopup.warningPopup("Please Enter Party !!");
            return;
        }

        const updatedData = Selectedrow?.filter(x => x.SELECTED == true)?.map(item => ({
            PKTID: item.PKTID,
            TYP: 'ADD',
            PARTYNAME: partyName
        }));

        const ObjJsonDet = {
            jsonObj1: updatedData,
            SPName: "API_AddToHoldData"
        };

        dispatch(addData(ObjJsonDet)).then(() => {
            setShowModalParty(false);
            setPartyName('');
            if (props.refreshData) {
                props.refreshData();
            } else {
                window.location.reload();
            }
        });
    };


    const handleSave = async (btnName, showModal) => {

        setpagebtnNaviName(btnName)


        if (btnName == 'Search') {
            if (PKTIDList?.length > 0) {
                const filteredData = props.DataSrc?.filter(item =>
                    PKTIDList.includes(item.PKTID)
                );
                setobjDs(filteredData);
            } else {
                setobjDs(JSON.parse(JSON.stringify(props.DataSrc || '[]')));
            }
            return;
        }
        if (btnName == 'Select All') {

            const allSelected = objDs.every(item => item.SELECTED); // Check if all are selected
            const updatedData = objDs?.map(item => ({
                ...item, SELECTED: !allSelected, // Toggle all based on current state
            }));

            setobjDs(updatedData);
            objDs = updatedData;
            setSelectedrow(updatedData);
            Selectedrow = updatedData;
            return;
        }

        let pktidArray = Array.isArray(Selectedrow) && Selectedrow?.filter(obj => obj.SELECTED == true && obj.PKTID)?.map(obj => obj.PKTID);
        setSelectedPktIds(pktidArray);
        if ((Selectedrow.length == undefined || Selectedrow.length == 0 || pktidArray.length == 0 || pktidArray == '' || pktidArray == undefined) && (btnName != 'Select All' && btnName != 'Filter' && btnName != 'Refresh' && btnName != 'WhatsApp')) {
            AlertPopup.warningPopup("Please Select atleast one Record !!");
            return
        }
        if ((btnName == 'Excel' && (Party?.Code == null || Party?.Code == undefined))) {
            AlertPopup.warningPopup("Please Select Party !!");
            return
        }

        const holdOrConfirmExists = Array.isArray(Selectedrow) && Selectedrow?.some(x => (x.IsHold || x.IsConfirm) && x.SELECTED == true);

        if (holdOrConfirmExists && btnName.includes('Remove') == false) {
            AlertPopup.warningPopup("This Packet Is Already Hold or Confirm For Other Party !!");
            return;
        }

        if (btnName == 'Refresh') {
            dispatch(startLoader());
            localStorage.removeItem('PktId');
            localStorage.removeItem('PktSearchData');
            JSON.parse(localStorage.getItem('isRefresh'))
            setObjSelTotal([]);
            if (props.refreshData) {
                props.refreshData()
            }
            dispatch(stopLoader());
        }

        if (btnName == 'Hold') {
            setShowModalParty(true);
            // const updatedData = pktidArray?.map(item => ({
            //     PKTID: item,
            //     TYP: 'ADD'
            // }));

            // let ObjJsonDet = {
            //     jsonObj1: updatedData,
            //     SPName: "API_AddToHoldData"
            // }
            // dispatch(addData(ObjJsonDet)).then(() => {
            //     if (props.refreshData) {
            //         props.refreshData();
            //     } else {
            //         window.location.reload();
            //     }
            // });

        }
        if (btnName == 'Remove Hold') {
            const updatedData = pktidArray?.map(item => ({
                PKTID: item,
                TYP: 'REMOVE'
            }));

            let ObjJsonDet = {
                jsonObj1: updatedData,
                SPName: "API_AddToHoldData"
            }
            dispatch(addData(ObjJsonDet)).then(() => {
                if (props.refreshData) {
                    props.refreshData();
                } else {
                    window.location.reload();
                }
            });
        }

        if (btnName == 'Excel') {
            if (btnName == 'Excel' && Party?.Code) {
                let selectedRowPktIds = Selectedrow?.map(x => x.PKTID && x.SELECTED)
                let payLoad = { AC_CODE: Party?.Code }
                if (selectedRowPktIds.length > 0) {
                    // payLoad.PKTID = selectedRowPktIds
                }
                let response = await dispatch(fetchWebStockPartyData(payLoad))
                let columnConfigName = APISetting?.find(x => x.AC_CODE == Party?.Code)?.COLUMNCONFIG;
                ExcelGen(response, columnConfigName, Party.Name);
            } else {
                ExcelGen(Selectedrow, 'PACKETSEARCH', 'Stock');
            }
        }

        if (btnName === 'Filter') {
            setopenPacketSearchCom(true)
        }
        if (btnName == 'DeleteAll') {

            const updatedData = pktidArray?.map(item => ({
                PKTID: item
            }));

            let ObjJsonDet = {
                jsonObj1: updatedData,
                SPName: pageName == 'STONESEARCH' ? "API_StnSearchPktDel" : "API_PktIdAllDetailDelete"
            }
            // dispatch(addData(ObjJsonDet));

            dispatch(addData(ObjJsonDet)).then(() => {
                if (props.refreshData) {
                    props.refreshData();
                } else {
                    window.location.reload();
                }
            });

        }

    }



    const handleOpenModal = () => {
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
    };

    const handleCloseModalVideoLink = () => {
        setisModalVideoLink(false);
    };



    const getAllData = () => {
        let Typ = localStorage.getItem('DataFilterFromDashboard');
        if (props.DataSrc) {
            if (Typ == 'COUNT') {
                setobjDs(JSON.parse(JSON.stringify(props.DataSrc || '[]')));
            }
            else if (Typ == 'HOLD') {
                setobjDs(JSON.parse(JSON.stringify(props.DataSrc?.filter(x => x.IsHold == true) || '[]')));
            }
            else if (Typ == 'AVAILABLE') {
                setobjDs(JSON.parse(JSON.stringify(props.DataSrc?.filter(x => x.IsHold == false) || '[]')));
            }
            else {
                setobjDs(JSON.parse(JSON.stringify(props.DataSrc || '[]')));
            }
        }
    }

    const [options, setOptions] = useState([]);
    const [OptLoc, setOptLoc] = useState([]);
    const [OptAcc, setOptAcc] = useState([]);
    const [MfgParoptions, setMfgParOptions] = useState([]);
    const [userRole, setuserRole] = useState('')


    useEffect(() => {

        const fetchData = async () => {
            if (DropDown.USERS) {
                let UserRole = DropDown.USERS.find(x => x.UserName == JSON.parse(localStorage.getItem('loginUserDetail'))?.UserName);
                if (UserRole) {
                    setuserRole(DropDown.ROLES.find(x => x.ValueKey == UserRole.RoleId)?.DisplayName)
                    setParty({ Code: UserRole.AC_CODE })
                }
            }
        };
        if (DropDown) {
            fetchData();
        }

    }, [DropDown]);
    ///For Cell Color 
    function getCellTheme(dataRow, columnKey) {
        let colorProperty = Object.keys(dataRow)?.filter(x => x?.endsWith('_COLOR'))
        for (let x of colorProperty) {
            if (x?.split('_COLOR')?.length > 0) {
                if (dataRow[x] && columnKey == x?.split('_COLOR')[0]) {
                    return {
                        bgCell: dataRow[x].toLowerCase()
                    }
                }
            }
        }
    }


    const getActionButton = (dataRow, columnKey) => {
        if (columnKey.toLowerCase() === "certno") {
            return {
                ...GridActionButton.LinkButton,
                title: dataRow.REPORTLINK,
                onClick: () => {
                    window.open(dataRow.REPORTLINK, "_blank");
                },
            };
        }
        else {
            return undefined;
        }
    };

    const displayType = (vType) => {
        setViewType(vType)
        changeContentHeight()
    }

    function PreloadImages(imageUrls) {
        const promises = imageUrls?.map((url, index) =>
            new Promise((resolve, reject) => {
                const img = new Image();
                img.src = url;
                img.onload = () => {
                    resolve();
                };
                img.onerror = reject;
            })
        );
        Promise.all(promises).catch(() => {
        });
    }

    useEffect(() => {
        if (objDs && (ViewType == 'CardView' || ViewType == 'BestPairCardView')) {
            PreloadImages(objDs.slice(1, 100)?.map(x => x.PHOTOROTED))
        }
    }, [objDs, ViewType])

    useEffect(() => {
        if (objDs) {
            const newItems = objDs.slice(0, 20);
            visibleItems = [...newItems];
            setVisibleItems([...visibleItems]);
        }
    }, [ViewType, objDs])


    useEffect(() => {
        window.addEventListener('resize', (e) => {
            changeContentHeight()
        })
        changeContentHeight()
    }, []);

    const changeContentHeight = () => {
        let StoneStatusHeight = document.querySelector('.StoneStatus')?.clientHeight;
        let totalDivHeight = document.querySelector('.totalDiv')?.clientHeight;
        let btndivHeight = document.querySelector('.btndiv')?.clientHeight;
        setcardViewHeight(window.innerHeight - 40 - (StoneStatusHeight + totalDivHeight + btndivHeight + 55))
    };


    const handlePKTIDClick = (rowData, column) => {
        // Ensure the clicked column is "PKTID"
        if (column === 'STNSTATUS' && rowData?.PKTID) {
            setisModalVideoLink(true);
            setVideoLinkRow([rowData]);
        }
    };

    const gridHeight = useAutoAdjustHeight(showTotal, objTotal); 
    const gridContent = useMemo(() => {
        return <>
            {
                ViewType == 'GridView' && objViewPara && objViewPara?.length > 0 &&
                <GlidGrid
                    data={objDs}
                    columns={objViewPara}
                    height={`${gridHeight}px`}
                    getCellTheme={getCellTheme}
                    GetselectedRow={GetselectedRow}
                    ActionButton={getActionButton}
                    getaction
                    headerHeight={30}
                    ExcelGet={'GetStkData'}
                    ViewparaName={pageName}
                    onCellDoubleClicked={(rowData, column) => handlePKTIDClick(rowData, column)}
                />
            }
        </>
    }, [ViewType, objDs, objViewPara, gridHeight])


    const MobViewFunc = () => {
        setIsMobView(true)
        displayType('MobView')
    }

    useEffect(() => {
        const isMobile = window.innerWidth <= 768;
        if (isMobile) {
            MobViewFunc();
        }
    }, []);


    const handlePKtIdFilter = (e) => {
        const input = e.target.value;
        setPKTIDList(input);

        if (input?.trim().length > 0) {
            const inputValues = input
                .toLowerCase()
                .split(' ')
                ?.map(val => val.trim())
                ?.filter(val => val.length > 0);

            const filteredData = props.DataSrc?.filter(item => {
                const pktid = item.PKTID?.toLowerCase() || '';
                return inputValues?.some(val => pktid.startsWith(val) || pktid.includes(val));
            });

            setobjDs(filteredData);
            objDs = filteredData;
        } else {
            const originalData = JSON.parse(JSON.stringify(props.DataSrc || []));
            setobjDs(originalData);
            objDs = originalData;
        }
    };



    const longPressTimer = useRef(null);
    const [visibleCount, setVisibleCount] = useState(20);
    const observerTarget = useRef(null);
    const [selectedPktIds, setSelectedPktIds] = useState([]);
    const [selectionMode, setSelectionMode] = useState(false);
    let visibleData = [];

    const loadMore = useCallback(() => {
        setVisibleCount(prev => {
            const next = prev + 20;
            return next <= objDs.length ? next : objDs.length;
        });
    }, [objDs.length]);
    useEffect(() => {
        const observer = new IntersectionObserver(
            entries => {
                if (entries[0].isIntersecting) {
                    loadMore();
                }
            },
            {
                root: null,
                rootMargin: '0px',
                threshold: 0.1,
            }
        );

        const currentObserverTarget = observerTarget.current;
        if (currentObserverTarget) {
            observer.observe(currentObserverTarget);
        }

        return () => {
            if (currentObserverTarget) {
                observer.unobserve(currentObserverTarget);
            }
        };
    }, [loadMore, IsMobView]);

    const handleLongPressStart = () => {
        longPressTimer.current = setTimeout(() => {
            setSelectionMode(true);
        }, 700);
    };

    const handleLongPressEnd = () => {
        clearTimeout(longPressTimer.current);
    };

    const handleCheckboxChange = (pktId) => {
        if (selectionMode) {
            setobjDs(prevData => {
                const updatedData = prevData?.map(item => {
                    if (item.PKTID === pktId) {
                        return { ...item, SELECTED: !item.SELECTED };
                    }
                    return item;
                });
                const selectedIds = updatedData?.filter(item => item.SELECTED)?.map(item => item.PKTID);
                const selectedData = updatedData?.filter(item => item.SELECTED);

                setSelectedPktIds(selectedIds);
                setSelectedrow(selectedData);
                return updatedData;
            });
        }

    };

    visibleData = objDs.slice(0, visibleCount);
    useEffect(() => {
        visibleData = objDs.slice(0, visibleCount);
    }, [objDs, IsMobView])


    const [isSwitchOn, setIsSwitchOn] = useState(false);

    const handleSwitchChange = (e) => {
        setIsSwitchOn(e.target.checked);
        setSelectedPlatformName('');
    };

    let [PlatformDet, setPlatformDet] = useState([])
    const [ShowPlatformDet, setShowPlatformDet] = useState(false)
    const GetPlatformData = async () => {
        setShowPlatformDet(true);
        let ObjJsonDet = {
            jsonObj1: [],
            SPName: 'API_PlatformMastAPI'
        }
        let res = await DynamicFetchNew(ObjJsonDet);
        setPlatformDet(res)
        PlatformDet = res;
    }

    const onPlatformDoubleCLick = async (rowData, columnName) => {
        debugger
        // let GetDet = await HttpMethod.post(`/api/PlatformStock/GetStock?APIKey=${rowData.APIKey}`);
        let ObjJsonDet = {
            jsonObj1: [{ PLATFORMID: rowData.PlatformID, APIKEY: rowData.APIKey }],
            SPName: 'API_GetStockForPlatformNew'
        }
        let res = await DynamicFetchNew(ObjJsonDet);
        if (res?.length > 0) {
            setobjDs(res);
            setSelectedPlatformName(rowData.PLATFORMNAME);
            setobjViewPara(columnConfigRecord?.filter(x => x.MenuCode == 'GetStkData'));
            objViewPara = columnConfigRecord?.filter(x => x.MenuCode == 'GetStkData');
        }
        setShowPlatformDet(false);
    }
    useEffect(() => {
        if (isSwitchOn == false) {
            setobjDs(JSON.parse(JSON.stringify(props.DataSrc || '[]')));
            setobjViewPara(props.ViewPara);
            setSelectedPlatformName('');
        }
    }, [isSwitchOn])


    const [show, setShow] = useState(false)
    const handleClose = () => setShow(false)
    const FileName = "";
    const handleDone = async (data) => {
        if (data.data) {
            dispatch(startLoader());
            const modifiedData = data.data?.map(item => ({
                PKTID: item["PKTID"],
                MFGID: item["MFGID"],
                LOTNAME: item["LOTNAME"],
                STATUS: item["STATUS"],
                CARAT: parseFloat(item["CARAT"]),
                SHAPE: item["SHAPE"],
                COLOR: item["COLOR"],
                CLARITY: item["CLARITY"],
                CUT: item["CUT"],
                POLISH: item["POLISH"],
                SYMMETRY: item["SYMMETRY"],
                FLUORESCENCE: item["FLUORESCENCE"],
                FLUORESCENCECOLOR: item["FLUORESCENCE COLOR"],
                RAPRATE: parseFloat(item["RAPRATE"]),
                DISCOUNT: parseFloat(item["DISCOUNT"]),
                PRICE: parseFloat(item["PRICE"]),
                LAB: item["LAB"],
                CERTIFICATENO: item["CERTIFICATE NO"],
                CERTIFICATEDATE: item["CERTIFICATE DATE"],
                LENGTH: parseFloat(item["LENGTH"]),
                WIDTH: parseFloat(item["WIDTH"]),
                HEIGHT: parseFloat(item["HEIGHT"]),
                MEASUREMENTS: item["MEASUREMENTS"],
                RATIO: parseFloat(item["RATIO"]),
                TABLEPER: parseFloat(item["TABLE %"]),
                TABLEMM: parseFloat(item["TABLE MM"]),
                CROWNANGLE: parseFloat(item["CROWN ANGLE"]),
                CROWNHEIGHTPER: parseFloat(item["CROWN HEIGHT  %"]),
                CROWNHEIGHTMM: parseFloat(item["CROWN HEIGHT MM"]),
                PAVILIONANGLE: parseFloat(item["PAVILION ANGLE"]),
                PAVILIONDEPTHPER: parseFloat(item["PAVILION DEPTH  %"]),
                PAVILIONDEPTHMM: parseFloat(item["PAVILION DEPTH MM"]),
                DEPTHPER: parseFloat(item["DEPTH %"]),
                DEPTHMM: parseFloat(item["DEPTH MM"]),
                GIRDLEPER: parseFloat(item["GIRDLE %"]),
                GIRDLENAME: item["GIRDLE NAME"],
                GIRDLECONDITION: item["GIRDLE CONDITION"],
                VIDEOLINK1: item["VIDEOLINK1"],
                VIDEOLINK2: item["VIDEOLINK2"],
                PHOTOLINK: item["PHOTOLINK"],
                KEYTOSYMBOLS: item["KEY TO SYMBOLS"],
                DIAMONDTYPE: item["DIAMOND TYPE"],
                COUNTRY: item["COUNTRY"],
                LOCATION: item["LOCATION"],
                INSCRIPTION: item["INSCRIPTION"],
                LOWER: parseFloat(item["LOWER"]),
                STRLENGTH: parseFloat(item["STR LENGTH"]),
                CULETSIZE: item["CULET SIZE"],
                CULETEPER: parseFloat(item["CULETE %"]),
                FACET: item["FACET"],
                HA: item["H&A"],
                NATTS: item["NATTS"],
                BGM: item["BGM"],
                BROWN: item["BROWN"],
                GREEN: item["GREEN"],
                MILKY: item["MILKY"],
                SHADE: item["SHADE"],
                EYECLEAN: item["EYE CLEAN"],
                TABLEWHITE: item["TABLE WHITE"],
                SIDEWHITE: item["SIDE WHITE"],
                TABLEBLACK: item["TABLE BLACK"],
                SIDEBLACK: item["SIDE BLACK"],
                TABLEOPEN: item["TABLE OPEN"],
                SIDEOPEN: item["SIDE OPEN"],
                OPENPAVILION: item["OPEN PAVILION"],
                REPORTTYPE: item["REPORT TYPE"],
                FANCYCOLORINTENSITY: item["FANCY COLOR INTENSITY"],
                FANCYCOLOROVERTONE: item["FANCY COLOR OVERTONE"],
                FANCYCOLOR: item["FANCY COLOR"],
                COMMENTS: item["COMMENTS"],
                RATE1: parseFloat(item["RATE1"]),
                RATE2: parseFloat(item["RATE2"]),
                RATE3: parseFloat(item["RATE3"]),
                RATE4: parseFloat(item["RATE4"]),
                PARTYNAME: ["PARTYNAME"]
            }));

            debugger;
            const ObjJson = {
                jsonObj1: convertKeysToUpperCase(modifiedData),
                SPName: "API_StkTrnPartyFTPSave"
            };
            try {
                await FTPSaveData(ObjJson); 
            } catch (error) {
                console.error("Error saving data:", error);
            } finally {
                dispatch(stopLoader()); 
                setShow(false);
            }
        } else {
            console.warn("No data found in response.");
        }
    };

    const FTPSaveData = async (ObjJson) => {
        dispatch(startLoader);
        try {
            await dispatch(addData(ObjJson));
            let ObjJsonDet = {
                jsonObj1: [],
                SPName: 'API_StkTrnDisp'
            };
            let res = await HttpMethod.post(`/SystemConfig/InsUpdDel/DynSpExAsyncDisp`, ObjJsonDet)
            setobjDs(res?.data?.DynDisp);
        } catch (error) {
            console.error("Upload failed:", error);
        }
        dispatch(stopLoader);
    }
    return (
        <>
            <Loader />
            <div className='bg-white gridTopHeight2 menupadd' style={{ zIndex: 100, top: PageName === 'STONESEARCH' ? 85 : 0 }}>
                <div className='row align-items-center p-2'>
                    <div className='col-9 pe-1 row'>
                        <div className='col-lg-4 col-7 Base-Input d-block d-md-flex justify-content-between pe-2'>
                            <input type="text" className='me-2' name="PktID"
                                value={PKTIDList}
                                onChange={(e) =>
                                    handlePKtIdFilter(e)
                                }
                                id=""
                                placeholder='Enter PKTID'
                            />
                        </div>

                        <div className='col-12 col-lg-2 butan-togle col-md-6 col-sm-11 align-column-right mar'>
                            <div className="icon-toggle-light">
                                <div
                                    className={`toggle-item ${pagebtnNaviName == 'Hold' ? 'selected' : ''}`}
                                    onClick={() => handleSave('Hold')} title="Hold"
                                >
                                    <FaHandHoldingMedical size={22} />
                                </div>
                                <div
                                    className={`toggle-item ${pagebtnNaviName == 'Remove Hold' ? 'selected' : ''}`}
                                    onClick={() => handleSave('Remove Hold')} title="Remove Hold"
                                >
                                    <MdPersonRemoveAlt1 size={22} />
                                </div>
                                <div
                                    className={`toggle-item ${pagebtnNaviName == 'Select ALL' ? 'selected' : ''}`}
                                    onClick={() => handleSave('Select All')} title="Select All"
                                >
                                    <BiSelectMultiple size={22} />
                                </div>
                            </div>
                        </div>

                        <div className="col- col-lg-5 d-flex mar">
                            <div className=''>
                                <div className="form-check form-switch">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                        style={{ cursor: 'pointer' }}
                                        checked={isSwitchOn}
                                        onChange={handleSwitchChange}
                                    />
                                </div>
                            </div>
                            {isSwitchOn && (
                                <div className=' d-flex align-content-center'>
                                    <button className='savepanelBtn btn-primary p-1' onClick={() => GetPlatformData()}>
                                        Get Platform Data
                                    </button>
                                    <span className='fw-bolder text-dark mx-2'>{SelectedPlatformName}</span>
                                </div>
                            )}
                        </div>

                    </div>
                    {/* Desktop View Icons - only visible on md and above */}
                    <div className='col-3 col-lg-3 col-md-3 d-none d-md-flex justify-content-end CursorPoinrer'>
                        <div className='d-flex justify-content-center align-items-center'>
                            <button className={`savepanelBtn btn-primary me-2 ${IsMobView == true ? 'd-none' : ''}`}
                                onClick={() => setShow(true)}
                            >
                                <MdFileDownload size={20} /> Import FTP File
                            </button>
                            <button className={`savepanelBtn btn-primary me-2 ${IsMobView == true ? 'd-none' : ''}`}
                                onClick={() => FileDownloader(SampleFile, 'Party Stock Sample File.xls')}
                            >
                                <MdFileDownload size={20} /> Sample File
                            </button>
                            <FaRectangleList
                                size={30}
                                color={ViewType == 'GridView' ? 'var(--IconColor)' : 'Gray'}
                                onClick={() => {
                                    setIsMobView(false);
                                    displayType('GridView');
                                }}
                            />
                            <FaMobileAlt
                                size={28}
                                className='ms-1'
                                onClick={() => MobViewFunc()}
                            />
                        </div>
                    </div>

                    {/* Mobile View Toggle Icons - only visible below md */}
                    <div className='col-2 col-lg-3 col-md-3 col-sm-2 d-block d-md-none text-end CursorPoinrer'>
                        <div className='d-flex justify-content-end align-items-end'>
                            {ViewType === 'GridView' ? (
                                <FaMobileAlt
                                    size={28}
                                    color='var(--IconColor)'
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        setIsMobView(true);
                                        displayType('MobView');
                                    }}
                                />
                            ) : (
                                <FaRectangleList
                                    size={30}
                                    color='var(--IconColor)'
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        setIsMobView(false);
                                        displayType('GridView');
                                    }}
                                />
                            )}
                        </div>
                    </div>


                </div>
            </div >

            <div className='Datacontainer'>
                <div ref={dataDivRef} className='dataDiv p-1' style={{ overflowY: 'auto' }}>
                    {gridContent}
                </div>
            </div >

            {/* {
                IsMobView == true && <PktSearchMobViewComp ShowMob={IsMobView} DataSrc={objDs}
                    onSelectedRowsChange={(selectedRows) => {
                        setSelectedrow(selectedRows)
                    }}
                />
            } */}

            {
                IsMobView == true && <div className='container-fluid align-items-center mb-2 px-2'>
                    <div className="row d-flex justify-content-between align-items-center">
                        {visibleData?.map((x, index) => (
                            <div
                                className='col-12 col-lg-4 col-sm-12 col-md-6 px-1'
                                key={index}
                                onMouseDown={handleLongPressStart}
                                onTouchStart={handleLongPressStart}
                                onMouseUp={handleLongPressEnd}
                                onMouseLeave={handleLongPressEnd}
                                onTouchEnd={handleLongPressEnd}
                            >
                                <Card striped bordered variant="dark" className='w-100 p-2 F13 mb-0 mt-2 mobile-card' onClick={() => handleCheckboxChange(x.PKTID)}>
                                    <div className="row d-flex">
                                        <div className="col-1 col-16 align-items-start justify-content-start pt-4 position-relative position-fixed-relative">
                                            <div
                                                className="transition-checkbox"
                                                style={{ transition: 'opacity 0.3s ease', opacity: selectionMode ? 1 : 0 }}
                                            >
                                                <input
                                                    type="checkbox"
                                                    value={x.SELECTED}
                                                    checked={selectedPktIds.includes(x.PKTID)}
                                                />
                                            </div>
                                            <div className="pt-2">
                                                {x.IsHold && (
                                                    <FaHandHoldingMedical size={15} color="#d90429" className="mb-2" />
                                                )}
                                            </div>
                                        </div>

                                        <div className='col-2 text-center col-17'>
                                            <div className='pktid'>{x.PKTID}</div>
                                            {shapeImageMap[x.S_NAME?.toUpperCase()] ? (
                                                <img
                                                    src={shapeImageMap[x.S_NAME?.toUpperCase()]}
                                                    alt={x.S_NAME}
                                                    className='pt-2 img-fluid imgWidth shape'
                                                />
                                            ) : (
                                                <div className='no-shape-box imgWidth px-2 m-1'>No image for shape</div>
                                            )}
                                            <div className='rap pt-2'>{x.S_NAME}</div>
                                        </div>


                                        <div className='col-3 ps-3 extrawidth'>
                                            <div className='rap'>{x.I_CARAT} {x.C_NAME} {x.Q_NAME}</div>
                                            <div className='text-center d-flex pt-1'>FIN : {x.CT_NAME} {x.PO_NAME} {x.SY_NAME}</div>
                                            <div className='d-flex pt-1'>FLOU : {x.FL_NAME}</div>
                                            {/* <div className="pt-1"> <img src={flaglogo} alt="" className='flaglogo img-fluid' />{x.LOCATION}</div> */}
                                            {/* <span className={`pt-1 fi fi-${x.LOCATION?.toLowerCase()}`}></span> */}
                                            <div className="pt-1 d-flex align-items-center">
                                                {(() => {
                                                    const rawCountry = x?.COUNTRY?.trim();
                                                    if (!rawCountry) return null;

                                                    const countryCode = countries.getAlpha2Code(rawCountry, 'en');
                                                    return countryCode ? (
                                                        <img
                                                            src={`https://flagcdn.com/w40/${countryCode.toLowerCase()}.png`}
                                                            alt={`${rawCountry} Flag`}
                                                            style={{ width: '17px', height: '10px', objectFit: 'cover' }}
                                                        />
                                                    ) : null;
                                                })()}
                                                {" "}{x.LOCATION}
                                            </div>
                                            <div className="" style={{ display: "flex", gap: "5px", alignItems: "center", flexWrap: "wrap" }}>
                                                <span>{x.LAB} :</span>
                                                <a
                                                    href={`${x.REPORTLINK}${x.CERTNO}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ color: "#007bff", textDecoration: "underline", cursor: "pointer" }}
                                                >
                                                    {x.CERTNO}
                                                </a>
                                            </div>

                                        </div>

                                        <div className='col-3 extrawidth ps-2'>
                                            <div className=''>{x.LENGTH} - {x.WIDTH} * {x.HEIGHT}</div>
                                            <div className='d-flex  pt-1'>T.: {x.TABLE_PER}</div>
                                            <div className="pt-1 ">D.: {x.TOTDEPTH_PER}</div>
                                            <div className="pt-1 ">RATIO : {x.RATIO}</div>
                                        </div>

                                        <div className='col-3 text-end pe-2 col-18'>
                                            <div className='rap'>RAP: {x.ORATE}</div>
                                            <div className='catat pt-1 '> {x.DISC} % </div>
                                            <div className='pktid pt-1'>{x.RATE} $/CT</div>
                                            <div className="pt-1 rap">$ {x.AMT}</div>
                                        </div>
                                    </div>
                                </Card>
                            </div>
                        ))}
                        {visibleCount < objDs.length && (
                            <div ref={observerTarget} className="mt-3 text-center">
                                <div>Loading more...</div>
                            </div>
                        )}
                    </div>
                </div>
            }

            <Modal show={isModalVideoLink} onHide={handleCloseModalVideoLink} className='left-side-modal'>
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    {
                        Array.isArray(VideoLinkRow) && VideoLinkRow.length > 0 ? (
                            VideoLinkRow?.map((x, i) => (
                                <React.Fragment key={i}>
                                    <div className='row'>
                                        <div className='col-12 text-center'>
                                            <img src={x?.PHOTOLINK} alt={`Image ${i}`} style={{ width: '100%', maxWidth: "466px" }}
                                            />
                                        </div>
                                    </div>
                                    <div className='row mt-3'>
                                        {/* Copy Image Link */}
                                        <div className='col-6'>
                                            <button className='btnOutlineBlue w-100' onClick={() => navigator.clipboard.writeText(x?.PHOTOLINK)}>
                                                <FaLink size={17} className='me-2' />
                                                Copy Image Link
                                            </button>
                                        </div>
                                        {/* Download Image */}
                                        <div className='col-6'>
                                            <button
                                                className='btnOutlineBlue w-100'
                                                onClick={async () => {
                                                    try {
                                                        const response = await fetch(x?.PHOTOLINK);
                                                        if (!response.ok) throw new Error('Failed to fetch image');
                                                        const blob = await response.blob();
                                                        const url = window.URL.createObjectURL(blob);

                                                        // Create a temporary <a> element for downloading the image
                                                        const a = document.createElement('a');
                                                        a.style.display = 'none';
                                                        a.href = url;
                                                        a.download = `${x?.PKTID}.jpg`; // Adjust file name and extension as needed
                                                        document.body.appendChild(a);
                                                        a.click();

                                                        // Clean up
                                                        window.URL.revokeObjectURL(url);
                                                        document.body.removeChild(a);
                                                    } catch (error) {
                                                        console.error('Error downloading image:', error);
                                                        alert('Failed to download the image. Please try again.');
                                                    }
                                                }}
                                            >
                                                <IoMdDownload size={17} className='me-2' />
                                                Download Image
                                            </button>
                                        </div>

                                    </div>
                                    <div className='row mt-1'>
                                        {/* Copy Video Link */}
                                        <div className='col-6'>
                                            <button className='btnOutlineBlue w-100' onClick={() => navigator.clipboard.writeText(x?.VIDEOLINK1)}>
                                                <FaLink size={17} className='me-2' />
                                                Copy Video Link
                                            </button>
                                        </div>
                                        {/* Download Video */}
                                        <div className='col-6'>
                                            <button
                                                className='btnOutlineBlue w-100'
                                                onClick={async () => {
                                                    try {
                                                        const response = await fetch(x?.VIDEOLINK1);
                                                        if (!response.ok) throw new Error('Failed to fetch video');
                                                        const blob = await response.blob();
                                                        const url = window.URL.createObjectURL(blob);

                                                        // Create a temporary <a> element for downloading the video
                                                        const a = document.createElement('a');
                                                        a.style.display = 'none';
                                                        a.href = url;
                                                        a.download = `${x?.PKTID}.mp4`; // Adjust file name and extension as needed
                                                        document.body.appendChild(a);
                                                        a.click();

                                                        // Clean up
                                                        window.URL.revokeObjectURL(url);
                                                        document.body.removeChild(a);
                                                    } catch (error) {
                                                        console.error('Error downloading video:', error);
                                                        alert('Failed to download the video. Please try again.');
                                                    }
                                                }}
                                            >
                                                <IoMdDownload size={17} className='me-2' />
                                                Download Video
                                            </button>
                                        </div>
                                    </div>
                                </React.Fragment>
                            ))
                        ) : (
                            <p>No videos available</p>
                        )
                    }
                </Modal.Body>
                {/* <Modal.Footer>
                    <button variant="secondary" className='btnbluedark' onClick={handleCloseModalVideoLink}> Close </button>
                </Modal.Footer> */}
            </Modal>
            <Modal show={ShowPlatformDet} onHide={() => { setShowPlatformDet(false) }}>
                <Modal.Header closeButton className='p-2'>
                    <Modal.Title className='fs-5'>Platform Details</Modal.Title>
                </Modal.Header>
                <Modal.Body className='p-2'>
                    {
                        PlatformDet?.length > 0 && GetPlatform?.length > 0 &&
                        <GlidGrid
                            data={PlatformDet}
                            columns={GetPlatform}
                            onCellDoubleClicked={onPlatformDoubleCLick}
                        />
                    }
                </Modal.Body>
            </Modal>

            {/* -------Hold Party Model--------- */}
            <Modal show={showModalParty} onHide={() => setShowModalParty(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Enter Party Name</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Party Name"
                            value={partyName}
                            onChange={(e) => setPartyName(e.target.value)}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex align-column-center'>
                        <button className='savepanelBtn btn-primary w-100 p-1 me-2' onClick={addToHold}>
                            Hold
                        </button>
                        <button className='savepanelBtn btn-primary w-100 p-1' onClick={() => setShowModalParty(false)}>
                            Cancel
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>


            <FileImpComp
                show={show}
                handleClose={handleClose}
                onDone={handleDone}
                FileName={FileName}
            />
        </>
    )

}

export default memo(DataListComp)